import { Content, Typography } from "@bbnpm/bb-ui-framework";
import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    a {
      color: ${({ theme }) => theme.colors.primary.action};
      text-decoration: none;
      &:hover {
        color: ${({ theme }) => theme.colors.primary.hover};
        text-decoration: none;
      }
    }
  `;

export const CenteredTitle = styled(Typography.LargeTitle)`
  text-align: center;
  padding: 1rem 0 3rem;
`;

export const CenteredArea = styled.div`
  padding: 1rem 2rem;
  width: calc(1160px + 2rem);
  margin: 0 auto;
`;

export const ErrorContent = styled(Content)`
  height: 100%;
  position: fixed;
  width: 100vw;
  left: 0;
  z-index: -1;
  .text-wrapper {
    text-align: center;
    width: 100%;
    position: absolute;
    top: 40%;
    opacity: 50%;
    transform: translateY(-50%);
  }
  h1 {
    font-size: 25em;
    margin: 0;
  }
  h2 {
    font-size: 4em;
    margin: 0;
  }
`;
